var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };} /** @format */

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getField } from 'react-redux-form';
import { Icon } from "../../UI";

// exported for testing.
export class MultipleEditionFieldWarningBase extends Component {
  render() {
    if (!this.props.touched || !this.props.multipleEdition) {
      return false;
    }
    return (/*#__PURE__*/
      _jsx("span", {}, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "exclamation-triangle" }), "\xA0"

      ));

  }
}






// exported for testing.
export const mapStateToProps = (state, props) => {
  const fieldState = getField(state, `${props.model}.${props.field}`) || { pristine: true };
  let touched = !fieldState.pristine;
  if (fieldState.$form) {
    touched = !fieldState.$form.pristine;
  }
  return { touched };
};

export default connect(mapStateToProps)(MultipleEditionFieldWarningBase);